import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FileDownloadRoundedIcon from "@mui/icons-material/FileDownloadRounded";
import Field from "../../../components/Field";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function BankingInformation(props: any) {
  const {
    bankDetails,
    commentDetails,
    bankStatementCopy,
    handleBankingCommentChange,
    bankingComment,
  } = props;
  const comments = commentDetails?.filter(
    (comment: any) => comment.section_type === "BANKING_INFORMATION"
  );
  return (
    <Grid container spacing={4} p={4} mt={5}>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Payable to" value={bankDetails?.payable_to} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Relationship" value={bankDetails?.relationship} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field
          label="Name of account holder"
          value={bankDetails?.account_holder}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Name of bank" value={bankDetails?.bank_name} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Account number" value={bankDetails?.account_number} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Branch" value={bankDetails?.branch} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Branch code" value={bankDetails?.branch_code} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Account type" value={bankDetails?.account_type} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field
          label="ID/Passport number"
          value={bankDetails?.passport_number}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field
          label="Source of funds/Income"
          value={bankDetails?.source_of_funds}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Occupation" value={bankDetails?.occupation} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Email address" value={bankDetails?.email_address} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Nationality" value={bankDetails?.nationality} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field
          label="Country of residence"
          value={bankDetails?.country_of_residence}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Country of Birth" value={bankDetails?.country_of_birth} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Account Type" value={bankDetails?.account_type} />
      </Grid>

      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Date" value={bankDetails?.submission_date} />
      </Grid>
      {bankStatementCopy?.map((doc: any, index: number) => {
        return (
          <Grid size={{ xs: 12 }}>
            <Box width={270} height={48}>
              <Typography fontWeight={600} textAlign="left" fontSize={18}>
                Bank Statement
              </Typography>
              <Box
                sx={{
                  background: "#F5EEE9",
                  color: "#FF0000",
                  borderRadius: 1,
                  px: 1.5,
                  py: 0.5,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <PictureAsPdfIcon />
                <Box
                  display="flex"
                  justifyContent="center"
                  flexDirection="column"
                >
                  <Typography fontSize={14}>{doc.file_name}</Typography>
                </Box>
                <IconButton
                  onClick={() => window.open(doc.file_url, "_blank")}
                  size="small"
                >
                  <FileDownloadRoundedIcon />
                </IconButton>
              </Box>
            </Box>
          </Grid>
        );
      })}

      {comments?.length > 0 && (
        <Grid size={12} mt={4}>
          {comments.map((comment: any, index: number) => (
            <Accordion
              key={index}
              sx={{
                backgroundColor: "#F7F7F7",
                boxShadow: "none",
                borderRadius: "6px",
                mb: 2,
                border: "1px solid #E0E0E0",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
                sx={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography fontWeight={600} fontSize={14}>
                    {comment.commentedByName}{" "}
                    <Typography
                      component="span"
                      fontWeight={600}
                      color="#EC6E00"
                    >
                      - {comment.role_at_time_of_comment?.toUpperCase()}
                    </Typography>
                  </Typography>
                  <Typography fontSize={12} color="text.secondary">
                    {new Date(comment.created_on).toLocaleTimeString("en-US", {
                      hour: "numeric",
                      minute: "2-digit",
                    })}{" "}
                    |{" "}
                    {new Date(comment.created_on).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  fontSize={15}
                  color="#333"
                  lineHeight={1.6}
                  textAlign="left"
                >
                  {comment.content}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid>
      )}
      <Grid size={{ md: 12 }} mt={4}>
        <Typography
          variant="body1"
          fontWeight={600}
          fontSize={18}
          sx={{ display: "block", textAlign: "left" }}
        >
          Comment
        </Typography>
        <TextField
          multiline
          rows={4}
          variant="outlined"
          fullWidth
          onChange={handleBankingCommentChange}
          value={bankingComment}
        />
      </Grid>
    </Grid>
  );
}
